export enum EmailImportsStatus {
  DUPLICATE= 'DUPLICATE',
  UNEXPECTED = 'UNEXPECTED',
  IMPORTED = 'IMPORTED'
}
